export const siteInfo = {
  name: "Scaleup Academy",
  tagline: "Unlock Your Potential. Scale Your Future.",

  phone: "+91 7770001406",
  whatsapp: "917770001406",
  email: "info@scaleupacademy.in",

  address: "Near Huda Market, Sector 1/4, Hisar, Haryana",

  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.5!2d77.32!3d28.57!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!5e0!3m2!1sen!2sin",

  socialLinks: {
    instagram: "https://instagram.com/scaleupacademy",
    facebook: "https://facebook.com/scaleupacademy",
    youtube: "https://youtube.com/@scaleupacademy",
    linkedin: "https://linkedin.com/company/scaleupacademy",
    twitter: "https://twitter.com/scaleupacademy"
  }
};


export const heroSlides = [
  {
    id: 1,
    headline: "Elite Preparation for",
    highlightedText: "CLAT",
    subHeadline: "Law as a Profession, Not Just an Exam",
    description:
      "Founder-led CLAT programs focused on legal reasoning, reading depth, and exam strategy — built for serious law aspirants.",
    badge: "Limited Seats",
  },

  {
    id: 2,
    headline: "Elite Preparation for",
    highlightedText: "IPMAT",
    subHeadline: "Early Path to IIMs & Top BBA Programs",
    description:
      "Strong foundation in aptitude, concepts, and exam strategy for IPMAT Indore, Rohtak, and leading BBA entrances.",
    badge: "Limited Seats",
  },

  {
    id: 3,
    headline: "Integrated Academic",
    highlightedText: "School Programs",
    subHeadline: "Classes IX–XII",
    description:
      "Custom-designed academic partnerships for CBSE schools with competitive alignment and outcome-driven learning.",
    badge: "Academic Partners",
  },
];


export const heroStats = [
  { value: "1:10", label: "Student–Teacher Ratio", subtext: "Small batches only" },
  { value: "Founder", label: "Personally Led Academics", subtext: "No outsourced teaching" },
  { value: "Custom", label: "Program Architecture", subtext: "Built per goal" },
  { value: "Results", label: "Accountability Model", subtext: "Measured outcomes" },
];



export const facultyData = [
  {
    name: "Dr. Rajesh Kumar",
    role: "Founder & Director",
    subject: "Legal Reasoning & Strategy",
    experience: "20+ Years",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop&crop=face",
  },
  {
    name: "Prof. Meera Iyer",
    role: "Head — CLAT Division",
    subject: "English & Current Affairs",
    experience: "15+ Years",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=face",
  },
  {
    name: "Mr. David Wilson",
    role: "Head — IELTS Division",
    subject: "IELTS Speaking & Writing",
    experience: "10+ Years",
    image: "https://images.unsplash.com/photo-1629425733761-caae3b5f2e50?w=400&h=400&fit=crop&crop=face",
  },
  {
    name: "Ms. Kavita Sharma",
    role: "Head — CUET Division",
    subject: "Quantitative & Logical Reasoning",
    experience: "12+ Years",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=400&fit=crop&crop=face",
  },
  {
    name: "Mr. Amit Verma",
    role: "Senior Faculty",
    subject: "Spoken English & Personality",
    experience: "8+ Years",
    image: "https://images.pexels.com/photos/2381069/pexels-photo-2381069.jpeg?w=400&h=400&fit=crop&crop=face",
  },
  {
    name: "Dr. Priya Nair",
    role: "Academic Counsellor",
    subject: "Career Guidance & Mentoring",
    experience: "14+ Years",
    image: "https://images.pexels.com/photos/762020/pexels-photo-762020.jpeg?w=400&h=400&fit=crop&crop=face",
  },
];

export const resultsData = {
  metrics: [
    { value: "5000+", label: "Students Mentored" },
    { value: "95%", label: "Academic Success Rate" },
    { value: "200+", label: "Top CLAT AIR Ranks" },
    { value: "50+", label: "School Academic Partnerships" },
  ],

  examsCovered: [
    "CLAT",
    "AILET",
    "SLAT",
    "IPMAT Indore",
    "IPMAT Rohtak",
    "CUET UG",
    "CUET PG"
  ],

  achievements: [
    "Elite CLAT results with consistent top AIR rankings",
    "Successful IPMAT selections across IIM Indore, Rohtak & Ranchi",
    "Official academic partner for multiple CBSE schools",
    "Strong retention and performance improvement in Classes IX–XII programs",
  ],
};


export const whyChooseData = [
  {
    title: "Founder-Led Academic Delivery",
    desc: "Programs are personally supervised to ensure depth, quality, and accountability.",
  },
  {
    title: "Low Student Volume",
    desc: "We work with limited students so outcomes never suffer.",
  },
  {
    title: "Custom Designed Programs",
    desc: "No templates — every academic structure is built to fit student or school needs.",
  },
  {
    title: "Outcome Focused",
    desc: "Strategy, clarity, and measurable academic progress drive everything we do.",
  },
  {
    title: "Integrated Academic Alignment",
    desc: "School syllabus is strategically aligned with CLAT, IPMAT, and CUET foundations.",
  },
  {
    title: "Accountability-Driven Teaching",
    desc: "Continuous monitoring, feedback, and academic tracking ensure consistent progress.",
  },
];


export const courses = [
  {
    id: "clat",
    icon: "Scale",
    title: "CLAT – ELITE LAW PROGRAM",
    subtitle: "Preparing for Law as a Profession, Not Just an Exam",

    fullDesc:
      "The CLAT examination demands reading depth, logical clarity, and legal thinking.",

    duration: "1–2 Years",
    mode: "Offline + Online",
    batchSize: "20–25 Students",

    highlights: [
      "Constitutional principles and legal concepts",
      "Case-based reasoning",
      "Application-oriented problem solving",
      "Argument analysis & critical reasoning",
      "Law-oriented current affairs integration",
      "Sectional & full-length mock strategy"
    ],

    overview: {
      description:
        "The CLAT examination demands reading depth, logical clarity, and legal thinking.",
      approach:
        "At Scale Up Academy, CLAT preparation is approached as professional training for future lawyers, not mechanical coaching."
    },

    programFocus: {
      legalReasoning: [
        "Constitutional principles and legal concepts",
        "Case-based reasoning",
        "Application-oriented problem solving"
      ],
      logicalReasoning: [
        "Argument analysis",
        "Critical reasoning",
        "Pattern recognition and structured thinking"
      ],
      englishAndComprehension: [
        "Advanced reading comprehension",
        "Vocabulary in context",
        "Language precision"
      ],
      currentAffairsAndGK: [
        "Law-oriented current affairs",
        "Static + dynamic integration",
        "Conceptual understanding over memorisation"
      ],
      testingAndStrategy: [
        "Sectional and full-length mocks",
        "Performance analysis",
        "Exam-day strategy and rank planning"
      ]
    },

    targetAudience: [
      "Students targeting NLUs and top law colleges",
      "Learners willing to engage deeply with texts and ideas",
      "Students who value strategy over shortcuts"
    ],

    teachingMethodology: [
      "Small batch sizes",
      "Founder-led academic delivery",
      "Regular assessments with feedback",
      "Individual mentoring and academic tracking"
    ]
  },

  {
    id: "ipmat",
    icon: "GraduationCap",
    title: "IPMAT – INTEGRATED MANAGEMENT PROGRAM",
    subtitle: "Building Quantitative & Verbal Thinking for Future Leaders",

    fullDesc:
      "IPMAT is not just about mathematics or English. It tests thinking speed, clarity, and composure.",

    duration: "1–3 Years",
    mode: "Offline + Online",
    batchSize: "20–30 Students",

    highlights: [
      "Strong quantitative fundamentals",
      "Mental mathematics & speed techniques",
      "Logical reasoning & decision frameworks",
      "Advanced verbal ability training",
      "Interview & profile preparation",
      "Long-term academic mentoring"
    ],

    overview: {
      description: [
        "IPMAT is not just about mathematics or English.",
        "It tests thinking speed, clarity, and composure."
      ],
      approach:
        "At Scale Up Academy, IPMAT preparation is designed as a long-term intellectual training program."
    },

    coreAcademicAreas: {
      quantitativeAptitude: [
        "Conceptual clarity from fundamentals",
        "Mental mathematics & speed techniques",
        "Application-based problem solving"
      ],
      logicalReasoningAndDI: [
        "Data interpretation",
        "Logical frameworks",
        "Decision-making under time pressure"
      ],
      verbalAbility: [
        "Reading comprehension",
        "Grammar in usage",
        "Vocabulary development"
      ],
      interviewAndProfilePreparation: [
        "Personal interview training",
        "Communication skills",
        "Academic and extracurricular profiling"
      ]
    },

    targetAudience: [
      "Students aiming for IIM Indore, Rohtak, Ranchi",
      "Learners interested in management, entrepreneurship, or leadership",
      "Students seeking structured mentoring from Class IX onwards"
    ]
  },

  {
    id: "school-projects",
    icon: "Globe",
    title: "SCHOOL INTEGRATED ACADEMIC PROJECTS (CLASSES IX–XII)",
    subtitle: "Academic Partnership, Not External Coaching",

    fullDesc:
      "Scale Up Academy works with CBSE schools to design and deliver integrated academic programs that strengthen school outcomes and student preparedness.",

    duration: "Full Academic Year",
    mode: "On-Campus",
    batchSize: "School Based",

    highlights: [
      "Integrated academic planning",
      "CBSE + competitive exam alignment",
      "Foundation programs for CUET, CLAT & IPMAT",
      "Teacher mentoring & audits",
      "Regular performance reporting",
      "Single-point academic accountability"
    ],

    overview: {
      description:
        "Scale Up Academy works with CBSE schools to design and deliver integrated academic programs.",
      positioning:
        "This is a B2B academic partnership, not a mass coaching tie-up."
    },

    offeringsToSchools: [
      "Academic planning for Classes IX–XII",
      "CBSE syllabus alignment with competitive exams",
      "Foundation programs for CUET, CLAT & IPMAT",
      "Teacher mentoring and academic audits",
      "Periodic testing, analysis & reporting"
    ],

    optionalSchoolSpecific: [
      "JEE / NEET academic support (on demand, customised)"
    ],

    integrationProcess: [
      "Designed in consultation with school leadership",
      "Implemented within the school timetable",
      "Monitored through academic reviews",
      "Refined through performance data"
    ],

    reasonsSchoolsChooseUs: [
      "Reduced academic management burden",
      "Improved consistency across classes",
      "Stronger XI–XII retention",
      "Better parent confidence",
      "Single-point academic accountability"
    ],

    roleStatement: {
      philosophy: "We act as an academic partner, not just content providers.",
      emphasis: "Responsibility and outcomes matter to us."
    },

    customizationBasis: [
      "Student profile",
      "School goals",
      "Infrastructure",
      "Academic expectations"
    ]
  }
];


export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    course: "CLAT 2024",
    rating: 5,
    text: "Scale Up Academy transformed my preparation approach completely. The focus on legal reasoning and deep concept clarity helped me secure an AIR under 500. The mentoring and test analysis were outstanding.",
    avatar: "PS"
  },
  {
    id: 2,
    name: "Rahul Verma",
    course: "CUET UG 2024",
    rating: 5,
    text: "The academic planning and structured preparation made CUET feel manageable. I secured admission into my preferred university thanks to Scale Up Academy’s focused teaching and regular assessments.",
    avatar: "RV"
  },
  {
    id: 3,
    name: "Ananya Gupta",
    course: "IPMAT Indore",
    rating: 5,
    text: "Scale Up Academy’s long-term mentoring built my quantitative and verbal thinking step by step. The interview preparation was incredibly practical and boosted my confidence immensely.",
    avatar: "AG"
  },
  {
    id: 4,
    name: "Vikash Patel",
    course: "School Integrated Program (Class XI–XII)",
    rating: 5,
    text: "The integrated academic model helped me stay consistent in school while preparing for competitive exams. My concepts improved drastically and my performance became more stable across subjects.",
    avatar: "VP"
  },
  {
    id: 5,
    name: "Sneha Reddy",
    course: "CLAT 2023",
    rating: 5,
    text: "The current affairs with legal orientation and case-based reasoning made a huge difference in my CLAT score. The faculty’s personal mentoring kept me focused throughout the year.",
    avatar: "SR"
  },
  {
    id: 6,
    name: "Arjun Mehta",
    course: "IPMAT Rohtak",
    rating: 4,
    text: "Concept-first teaching and continuous performance tracking helped me improve steadily. The mock interviews and feedback sessions were especially valuable for final selection.",
    avatar: "AM"
  }
];


export const galleryImages = [
  {
    id: 1,
    title: "Smart Academic Classrooms",
    category: "Infrastructure",
    image: "https://images.unsplash.com/photo-1588072432836-e10032774350"
  },
  {
    id: 2,
    title: "Student Academic Orientation",
    category: "Events",
    image: "https://images.unsplash.com/photo-1523580846011-d3a5bc25702b"
  },
  {
  id: 4,
  title: "Faculty Training & Curriculum Workshop",
  category: "Faculty",
  image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1200&q=80"
},

  {
    id: 4,
    title: "Faculty Training & Curriculum Workshop",
    category: "Faculty",
    image: "https://images.unsplash.com/photo-1556761175-4b46a572b786"
  },
  {
    id: 5,
    title: "School Academic Partnership Meeting",
    category: "Events",
    image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d"
  },
  {
    id: 6,
    title: "Library & Study Resources",
    category: "Infrastructure",
    image: "https://images.unsplash.com/photo-1507842217343-583bb7270b66"
  },
  {
  id: 7,
  title: "CLAT & IPMAT Achievers Interaction",
  category: "Achievements",
  image: "https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?auto=format&fit=crop&w=1200&q=80"
},

  {
    id: 8,
    title: "Integrated Academic Planning Session",
    category: "Academics",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978"
  },
  {
    id: 9,
    title: "Campus Learning Environment",
    category: "Infrastructure",
    image: "https://images.unsplash.com/photo-1498243691581-b145c3f54a5a"
  }
];


export const aboutData = {
  mission:
    "To democratize quality education and empower every student to achieve their academic and professional dreams through expert guidance, innovative teaching methods, and unwavering support.",

  vision:
    "To become India's most trusted and impactful coaching academy, known for transforming lives through education excellence.",

  values: [
    { title: "Student First", desc: "Every decision we make starts with what's best for our students." },
    { title: "Excellence", desc: "We set the highest standards in teaching quality and results." },
    { title: "Innovation", desc: "We embrace modern teaching tools and adaptive learning methods." },
    { title: "Integrity", desc: "We maintain transparency in our processes and promises." }
  ],

  foundersMessage: {
    title: "Founder’s Message",

    intro:
      "Education today suffers from two extremes — either rote schooling or noisy coaching culture. Scale Up Academy was created to offer a third path.",

    experienceAreas: [
      "School education",
      "Competitive examinations",
      "Academic planning and mentoring"
    ],

    coreObservation:
      "Students are capable of far more than what routine systems demand — if guided correctly and early.",

    philosophy:
      "At Scale Up Academy, our focus is not speed, shortcuts, or volume. Our focus is thinking ability, academic clarity, and strategic direction.",

    whoWeWorkWith: [
      "Students serious about law and management careers",
      "Parents who want clarity rather than confusion",
      "Schools that value academic depth and long-term outcomes"
    ],

    programPrinciples: [
      "Personally supervised",
      "Academically structured",
      "Continuously monitored"
    ],

    closingNote:
      "We deliberately keep our scale limited so that quality never drops and responsibility remains clear."
  },

  team: [
    { name: "Dr. Rajesh Kumar", role: "Founder & Director", exp: "20+ years in education" },
    { name: "Prof. Meera Iyer", role: "Head - CLAT Division", exp: "15+ years in legal education" },
    { name: "Mr. David Wilson", role: "Head - IELTS Division", exp: "IELTS Certified, 10+ years" },
    { name: "Ms. Kavita Sharma", role: "Head - CUET Division", exp: "12+ years in competitive exams" }
  ]
};


export const technologyData = {
  intro: "At Scaleup Academy, we blend traditional teaching with cutting-edge technology to deliver an unparalleled learning experience.",
  features: [
    {
      title: "AI-Powered Analytics",
      desc: "Our AI system analyzes your performance patterns, identifies weak areas, and creates personalized study plans to maximize your preparation efficiency.",
      icon: "Brain"
    },
    {
      title: "Smart Classrooms",
      desc: "Interactive digital whiteboards, real-time quizzes, and multimedia content delivery make every class engaging and effective.",
      icon: "Monitor"
    },
    {
      title: "Online Learning Platform",
      desc: "Access recorded lectures, study materials, practice tests, and discussion forums anytime, anywhere through our dedicated learning portal.",
      icon: "Laptop"
    },
    {
      title: "Performance Dashboard",
      desc: "Track your progress with detailed analytics — test scores, attendance, topic mastery, and improvement trends — all in one dashboard.",
      icon: "BarChart3"
    },
    {
      title: "Mock Test Engine",
      desc: "Our proprietary test engine simulates actual exam conditions with adaptive difficulty, detailed solutions, and comparative analysis.",
      icon: "FileCheck"
    },
    {
      title: "Mobile Learning App",
      desc: "Learn on the go with our mobile app featuring bite-sized lessons, flashcards, daily quizzes, and push notifications for important updates.",
      icon: "Smartphone"
    }
  ]
};

export const trustData = [
  { icon: "Award", title: "Certified Faculty", desc: "All our trainers are certified professionals with years of domain expertise." },
  { icon: "Users", title: "Small Batch Size", desc: "We maintain small batches to ensure individual attention to every student." },
  { icon: "TrendingUp", title: "Proven Results", desc: "Consistent track record of top ranks and high scores across all courses." },
  { icon: "Clock", title: "Flexible Timings", desc: "Multiple batch options to fit your schedule — morning, evening, and weekends." },
  { icon: "BookOpen", title: "Study Material", desc: "Comprehensive, updated study material crafted by our expert faculty team." },
  { icon: "Headphones", title: "24/7 Support", desc: "Dedicated doubt-clearing support through WhatsApp, email, and portal." }
];

export const faqData = [
  {
    question: "Is Scale Up Academy a mass coaching institute?",
    answer:
      "No. We work with limited students and schools to maintain academic depth and accountability.",
  },
  {
    question: "Do you offer shortcut-based exam preparation?",
    answer:
      "No. Our focus is conceptual clarity, strategic thinking, and long-term academic strength.",
  },
  {
    question: "Are school programs standardized?",
    answer:
      "No. Every school partnership is custom-designed based on student profile and academic goals.",
  },
  {
    question: "Who leads the academic programs?",
    answer:
      "All core programs are founder-led with continuous monitoring and mentoring.",
  },
];

export const founderMessage = {
  title: "Founder & Director – Scale Up Academy",
  message:
    "We don’t focus on speed, shortcuts, or volume. We focus on thinking ability, clarity, and long-term academic outcomes. Every student and school we work with receives personal academic responsibility.",
};

export const philosophyData = {
  coreBeliefs: [
    "Depth over speed",
    "Why before how",
    "Strategy over shortcuts",
    "Responsibility for outcomes",
  ],
};